import { post, get, patch } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import {AdminUserUpsertDto} from "../types/user";

export const useFetchUserList = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get("user/list?pageNumber=" + data.pageNumber + "&pageSize=" + data.pageSize + "&statusFilter=" + data.statusFilter);
    }, options);
};

export const useSendVerificationCode = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await post("user/send-code", data, false);
    }, options);
};

export const useVerifyUserVerificationCode = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (verifiedData: any) => {
        return await patch("user/verify-code", verifiedData, false);
    }, options);
};

export const useSetPassword = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await patch("user/change-password", data);
    }, options);
};

export const useFetchUser = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("user/me");
    }, options);
};

export const useRegister = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await post("user/register", data, false);
    }, options);
};

export const useCompleteUserProfile = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await patch("traveller/complete-profile", data);
    }, options);
};

export const useFetchUserByPhoneNo = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get("user/phone-number?phoneNumber=" + data.phoneNumber);
    }, options);
};

export const useUpdateVerifiedStatus = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await patch("user/update-verified?userId=" + data.userId + "&codeType=" + data.codeType, {});
    }, options);
};

export const useGetAgentPayoutPreferences = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("agent/payout-preferences");
    }, options);
};

export const useGetUserPermission = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("user/permission-byid");
    }, options);
};

export const useGetAllPermission = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("user/getall-permission");
    }, options);
};

export const useGetAllRoles = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("user/user-roles-list");
    }, options);
};

export const useAddAdminUser = (options?: UseMutationOptions<any,any,any, any>) => {
return useMutation( async (data:AdminUserUpsertDto) => {
    return await post("user/register-admin", data);  
}, options);
}

export const useFetchAdminUserList = (
    options?: UseMutationOptions<any, any, any, any>
) => {
    return useMutation(async (data: any) => {

        let url = `user/adminuser-list?statusFilter=${data.statusFilter}`
            + `&searchFilter=${data.searchFilter}`
            + `&pageNumber=${data.pageNumber}`
            + `&pageSize=${data.pageSize}`;
        if (data.adminUserId) {
            url += `&adminUserId=${data.adminUserId}`;
        }

        return await get(url);
    }, options);
};


export const useDeleteAdminUserPermanently = (options: any) => {
    return useMutation(async (AdminUserID:string) => {
        return await patch(`user/${AdminUserID}/delete`, {});
    }, options);
};
